export const environment = {
  production: true,
  baseUrl:
    'https://hxa-gateway.happypond-8d21fcbd.germanywestcentral.azurecontainerapps.io/hxa-sparo',
  appVersion: require('../../package.json').version + '-stage-msa',
  unleash: {
    enabled: true,
    url: 'https://ftx.hxa.io/api/frontend/',
    clientKey:
      'default:production.af827fec9c7aaa935ad07b66610b60ef5b22329e0e1bd6061f71f1e2',
    appName: 'hxa-sparo-prod',
  },
};
